import { createContext, useCallback, useContext, useRef, useState } from "react";

const LightboxCtx = createContext(null);

const CLOSE_UNMOUNT_DELAY = 240;

export function LightboxProvider({ children }) {
  const [state, setState] = useState({ src: null, alt: "", large: false, shown: false });
  const closeTimer = useRef(null);

  const open = useCallback((src, alt, { large = false } = {}) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setState({ src, alt, large, shown: false });
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setState((s) => ({ ...s, shown: true })));
    });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, shown: false }));
    closeTimer.current = setTimeout(() => {
      setState({ src: null, alt: "", large: false, shown: false });
    }, CLOSE_UNMOUNT_DELAY);
  }, []);

  return (
    <LightboxCtx.Provider value={{ ...state, open, close }}>
      {children}
    </LightboxCtx.Provider>
  );
}

export function useLightbox() {
  const ctx = useContext(LightboxCtx);
  if (!ctx) throw new Error("useLightbox must be used within a LightboxProvider");
  return ctx;
}
